const registry = new Map();
export function registerHTLCClient(chainNamespace, factory) {
    registry.set(chainNamespace, factory);
}
export function createHTLCClient(chainNamespace, config) {
    const factory = registry.get(chainNamespace);
    if (!factory) {
        throw new Error(`No HTLC client registered for chain namespace: ${chainNamespace}. ` +
            `Did you forget to call the corresponding register function (e.g. registerEvmSdk())?`);
    }
    return factory(config);
}
export function getRegisteredNamespaces() {
    return Array.from(registry.keys());
}
const walletSignRegistry = new Map();
export function registerWalletSign(providerName, factory) {
    walletSignRegistry.set(providerName, factory);
}
export function deriveKeyFromWallet(providerName, config) {
    const factory = walletSignRegistry.get(providerName);
    if (!factory) {
        throw new Error(`No wallet sign registered for provider: ${providerName}. ` +
            `Did you forget to call the corresponding register function (e.g. registerEvmSdk())?`);
    }
    return factory(config);
}
export function getRegisteredWalletSignProviders() {
    return Array.from(walletSignRegistry.keys());
}
